import { render, staticRenderFns } from "./ArtificialServices.vue?vue&type=template&id=5d4cf0b8&scoped=true&"
import script from "./ArtificialServices.vue?vue&type=script&lang=js&"
export * from "./ArtificialServices.vue?vue&type=script&lang=js&"
import style0 from "./ArtificialServices.vue?vue&type=style&index=0&id=5d4cf0b8&lang=scss&scoped=true&"
import style1 from "./ArtificialServices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4cf0b8",
  null
  
)

export default component.exports